<form (ngSubmit)="onSubmit()" #filtroForm="ngForm">
    <label class="center-block">
        Motorista
    </label>
    <div class="input-group">
        <input [(ngModel)]="filtro.parametro" type="text" name="motorista" class="form-control input"
            style="min-width: 200px;" matTooltip="Preecha para a pesquisa de motorista"
            (ngModelChange)="search$.next($event)" [matAutocomplete]="auto" placeholder="digite aqui" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)='getPosts($event.option.value)'
            [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option" >
                {{option.busca}}
            </mat-option>
        </mat-autocomplete>
        <button type="submit" mat-icon-button style="margin-left: 10px" matTooltip="Abrir lista de motorista">
            <mat-icon aria-hidden="false" aria-label="Abrir lista de motorista" fontIcon="search">
            </mat-icon>
        </button>
        <button type="button" mat-icon-button style="margin-left: 10px"
            matTooltip="Limpe o resultado da pesquisa de motorista" (click)="limpaFiltro()">
            <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de motorista" fontIcon="delete">
            </mat-icon>
        </button>
    </div>
</form>
<div *ngIf="filtro.motorista" class="supercombo-selecionado panel panel-info">
    <div class="panel-body">
        <div class="row">
            <div class="col-md-3">
                <label>
                    Matrícula
                </label>
            </div>
            <div class="col-md-4">
                <label>
                    Apelido
                </label>
            </div>
            <div class="col-md-3">
                <label>
                    Cód. Motorista
                </label>
            </div>
            <div class="col-md-2">
                <label>
                    Status
                </label>
            </div>
        </div>
        <div class="row dados">
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.motorista.matricula }}</span>
            </div>
            <div class="col-md-4 ">
                <span class="mat-cell">{{ filtro.motorista.apelido }}</span>
            </div>
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.motorista.codigo }}</span>
            </div>
            <div class="col-md-2 ">
                <span class="mat-cell">{{ filtro.motorista.status }}</span>
            </div>
        </div>
    </div>
</div>